import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import CategorySection from './components/CategorySection';
import BenefitsSection from './components/BenefitsSection';
import HowItWorksSection from './components/HowItWorksSection';
import SafetySection from './components/SafetySection';
import SEOArticlesSection from './components/SEOArticlesSection';
import FAQSection from './components/FAQSection';
import ArticleCTASection from './components/ArticleCTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <WhatIsSection />
        <CategorySection />
        <BenefitsSection />
        <HowItWorksSection />
        <SafetySection />
        <SEOArticlesSection />
        <FAQSection />
        <ArticleCTASection />
      </main>
      <Footer />
    </div>
  );
}